export const Temperature = () => (
  <svg width="34" height="58" viewBox="0 0 34 58" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter
        x="-58.3%"
        y="-25%"
        width="216.7%"
        height="150%"
        filterUnits="objectBoundingBox"
        id="xjdbtck3da"
      >
        <feOffset dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#xjdbtck3da)" transform="translate(8 8)" fill="#FFF" fillRule="nonzero">
      <path d="M9 38.258a5.303 5.303 0 0 1-3.811-1.616 5.569 5.569 0 0 1-1.578-3.906c0-1.526.601-2.904 1.578-3.905a5.366 5.366 0 0 1 3.17-1.584V4.545A.65.65 0 0 1 9 3.888a.65.65 0 0 1 .641.657v22.702a5.275 5.275 0 0 1 3.171 1.584 5.569 5.569 0 0 1 1.577 3.905c0 1.526-.6 2.905-1.577 3.906A5.303 5.303 0 0 1 9 38.258zM6.03 1.264a4.36 4.36 0 0 0-1.233 3.044v20.314l-.32.19a9.187 9.187 0 0 0-3.284 3.38A9.293 9.293 0 0 0 0 32.778 9.34 9.34 0 0 0 2.634 39.3C4.26 40.966 6.51 42 9 42c2.482 0 4.732-1.034 6.366-2.7A9.31 9.31 0 0 0 18 32.779a9.29 9.29 0 0 0-1.193-4.586 9.125 9.125 0 0 0-3.283-3.38l-.32-.19V4.308a4.36 4.36 0 0 0-1.234-3.044A4.152 4.152 0 0 0 9 0C7.845 0 6.79.484 6.028 1.264z" />
      <path d="M9 28.52a4.074 4.074 0 0 0-2.906 1.23 4.244 4.244 0 0 0-1.201 2.98c0 1.164.464 2.214 1.2 2.978a4.041 4.041 0 0 0 2.908 1.23 4.074 4.074 0 0 0 2.906-1.23 4.244 4.244 0 0 0 1.201-2.979 4.278 4.278 0 0 0-1.2-2.978A4.041 4.041 0 0 0 9 28.52z" />
    </g>
  </svg>
);
